import type { AeMeeting } from '../../../api/projectManagement';

/**
 * Mirrors KNOWN_SUPPLIER_DOMAINS in packages/api/src/modules/project-management/meeting-audience.ts:
 * vendors and SEQUESTO's own banks that have no Attio type yet.
 */
const KNOWN_NON_PROSPECT_DOMAINS: ReadonlySet<string> = new Set(['outboundie.com', 'kbc.be', 'kbc.com', 'revolut.com']);

/**
 * Pure: an untyped or booked meeting whose outside companies are all known non-prospects: our bank, or a customer on the
 * CSM list (`customerDomains`, bare lower-case domains; Thoropass "Biweekly Sync" had no Attio type). Exported for tests.
 */
export function isKnownNonProspect(
  m: Pick<AeMeeting, 'audience' | 'companies'>,
  customerDomains: ReadonlySet<string> = new Set(),
): boolean {
  return (
    (m.audience === 'untyped' || m.audience === 'booked') &&
    m.companies.length > 0 &&
    m.companies.every((c) => {
      const parts = c.domain.toLowerCase().split('.');
      return parts.some((_, i) => {
        const suffix = parts.slice(i).join('.');
        return i < parts.length - 1 && (KNOWN_NON_PROSPECT_DOMAINS.has(suffix) || customerDomains.has(suffix));
      });
    })
  );
}
